var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 22,
    viewBox: "0 0 24 24",
    fill: "#fff",
    width: 22,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m1.293 12.707 4 4a1 1 0 1 0 1.414-1.414l-3.293-3.293 3.293-3.293a1 1 0 1 0 -1.414-1.414l-4 4a1 1 0 0 0 0 1.414z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m18.707 7.293a1 1 0 1 0 -1.414 1.414l3.293 3.293-3.293 3.293a1 1 0 1 0 1.414 1.414l4-4a1 1 0 0 0 0-1.414z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m13.039 4.726-4 14a1 1 0 0 0 .686 1.236 1.053 1.053 0 0 0 .275.038 1 1 0 0 0 .961-.726l4-14a1 1 0 1 0 -1.922-.548z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCode);
export default __webpack_public_path__ + "static/media/code.8a87d934be668276d266d27ec9e9f0bf.svg";
export { ForwardRef as ReactComponent };